import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/pde-oel-reports")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/pde-oel-reports", statusCode: 301 }); },
});
